module.exports = __webpack_public_path__ + "img/turkina.d46b3edf.jpg";